import Image from 'next/image';
import truckSmarterAppIconSvg from './trucksmarter-app-icon.svg';
import DallasImageProps from '../dallas-image-props';

export default function TruckSmarterAppIcon(props: DallasImageProps) {
  return (
    <Image
      {...props}
      src={truckSmarterAppIconSvg}
      alt="TruckSmarter's App Icon"
    />
  );
}
